import { toast as originalToast, Id, Content, ToastOptions, UpdateOptions } from 'vue3-toastify';
import i18n from '@/plugins/i18n';

// В vue3-toastify он не помечен на export. Поэтом сами объявляем
declare type OmitLoadingOptsToastOption = Omit<ToastOptions, 'isLoading' | 'draggable'>;
declare type OmitTypeToastOption = Omit<ToastOptions, 'type' | 'disabledEnterTransition'>;

function getLocalContent(content: Content): string|Content {
  return typeof content === 'string' ? i18n.global.t(content) : content
}

export const toast = {
  ...originalToast,
  success: (content: Content, options?: OmitTypeToastOption): Id => {
    return originalToast.success(getLocalContent(content), options)
  },
  error: (content: Content, options?: OmitTypeToastOption): Id => {
    return originalToast.error(getLocalContent(content), options)
  },
  warn: (content: Content, options?: OmitTypeToastOption): Id => {
    return originalToast.warn(getLocalContent(content), options)
  },
  warning: (content: Content, options?: OmitTypeToastOption): Id => {
    return originalToast.warning(getLocalContent(content), options)
  },
  info: (content: Content, options?: OmitTypeToastOption): Id => {
    return originalToast.info(getLocalContent(content), options)
  },
  loading: (content: Content, options?: OmitLoadingOptsToastOption): Id => {
    return originalToast.loading(getLocalContent(content), options)
  },
  update: (toastId: Id, options?: UpdateOptions): void => {
    if (options.render !== undefined && options.render !== null) {
      options.render = i18n.global.t(String(options.render))
    }
    originalToast.update(toastId, options)
  }
};